import { deviceTypes, TaskQL, Task } from './../../providers/tasks/models';
import { TasksProvider } from './../../providers/tasks/tasks';
import { UtilsProvider } from './../../providers/utils/utils';
import { TasksPage } from './../tasks/tasks';
import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  Platform,
  AlertController
} from 'ionic-angular';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { ENV } from '../../environments/environment';

@IonicPage()
@Component({
  selector: 'page-task-decline',
  templateUrl: 'task-decline.html'
})
export class TaskDeclinePage {
  private task: TaskQL;
  private customer: any;
  private message: string = '';
  private ready: boolean;
  private reason: string = '';
  private loading: boolean = false;
  declineReason: string = '';
  filteredReasons: Array<any>

  private images: Array<any> = new Array(0);
  private attachments: Array<any> = new Array();

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private camera: Camera,
    private platform: Platform,
    private alertCtrl: AlertController,
    private utilsProvider: UtilsProvider,
    private tasksProvider: TasksProvider
  ) {
    this.task = this.navParams.get('task');
    this.customer = this.navParams.get('customer');
  }

  ionViewDidLoad() {}

  readyCheck() {
    let flag = true;
    for (let i = 0; i < 4; i++) {
      if (!this.images[i]) {
        flag = false;
      }
    }
    //if(this.images.length == 0)
    this.ready = flag;
  }


  isCordova() {
    return this.platform.is('cordova');
  }
 
  declineTask() {
    this.loading = true;
    let reasonTxt = this.reason;
    
    this.tasksProvider.declineTask(this.task, reasonTxt).subscribe(res => {
      this.navCtrl.pop();
      this.navCtrl.pop();
    });
  }

  disableCheck(){
    let trimmedReason = this.reason.trim();
    if(this.loading) return true;
    if(trimmedReason.length < 5) return true;
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/pages/task-decline/task-decline.ts